import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../stores/Hooks';
import { ModalTypeEnum } from '../../stores/libraries/ModalLibrary';

export const ModalMessageStatementPreview: React.FC<any> = observer(
	() =>
	{
		const { uiState, dataState } = useStores();
		const store = uiState.modal;
		return (
			<>
				<div className="modal-content">
					<div className="docs">
						<div className="doc">
							<iframe src={dataState.GetFormLink()} width="100%" height="500px" title="Сформированная форма"></iframe>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="d-flex align-items-center">
						<button
							className="btn btn-secondary"
							onClick={() => { store.setShowModal(false); }}
						>Отменить</button>
						<button
							className="btn btn-primary ml-auto"
							onClick={() => { store.setShowModal(true, ModalTypeEnum.StatementSignSelector, 'Подписание заявления оператора ЭДО'); }}
						>Подписать</button>
					</div>
				</div>
			</>
		);
	}
)
